// extracted by mini-css-extract-plugin
module.exports = {"arrow":"DataSyncArrow_arrow__23KxZ","inverted":"DataSyncArrow_inverted__3rVKr","active":"DataSyncArrow_active__2oNLI"};